/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import styled from 'styled-components';
import {compose} from 'ramda';
/**
 * The internal dependencies.
 */
import FlexRootWrapper from '../../../components/general/flex-root';
import Button from '../../../components/general/button';
import Chevron from '../../../components/general/navigation-chevron';
import Bar from '../../../components/task/bar';
import BackButton from '../../../components/general/back-button';
import {tasksDeselect, tasksUpdate} from '../../../store/tasks/actions';
import {getTasksCurrent} from '../../../store/tasks/selectors';

const ContentWrapper = styled(FlexRootWrapper)`
	background: #686871;
	justify-content: center;
	align-items: center;
`;

const BaseButtonStyles = `
	display: flex;
	align-items: center;
	justify-content: center;

	width: 178px;
	font-size: 14px;
	border-width: 2px;
	background: #fff;
`;

const TaskButton = styled(Button)`
	${BaseButtonStyles}

	margin-bottom: 28px;
`;

class Task extends React.Component {
    initializeTaskProgress = () => {
        const {task, tasksUpdate, history} = this.props;

        tasksUpdate(task.id, {status: 'in-progress'});
        history.push('/dashboard/working');
    };

    returntask = () => {
        const {task, tasksUpdate, history, tasksDeselect} = this.props;
        // console.debug('Task return:', task);
        tasksUpdate(task.id, {status: '', worker: ''});
        tasksDeselect();
        history.push('/dashboard/shop');
    };

    render() {
        const {task, tasksDeselect} = this.props;

        return (
            <FlexRootWrapper>
                <Bar
                    longNumber={task.erpnumber}
                    task={task}
                    onClose={tasksDeselect}
                />

                <ContentWrapper>
                    <TaskButton onClick={this.initializeTaskProgress}>
                        Auftrag ausführen

                        <Chevron/>
                    </TaskButton>

                    <BackButton
                        handleClick={this.returntask}
                        text="zurückgeben"
                    />
                </ContentWrapper>
            </FlexRootWrapper>
        );
    }
}

export default compose(
    connect(
        (state) => ({
            task: getTasksCurrent(state),
        }), {
            tasksDeselect,
            tasksUpdate,
        }
    ),
    withRouter
)(Task);



// WEBPACK FOOTER //
// ./src/containers/task/stock/index.js